export const parseOverviewChallengeContent = (
	content: string
): { challenges: string[]; overview: string } => {
	const contentLines = content.split('\n')

	const firstNonEmptyLine = contentLines.find((line) => line.trim() !== '')
	/**
	 * A challenge is denoted by a numbered list in the input textfield when a user
	 * is editing the persona overview and challenges. This is to catch when a user
	 * only inputs challenges and no overview.
	 * */
	const startsWithChallenge =
		firstNonEmptyLine?.match(/^\d+\.\s*(\S.*)$/) != null

	const { overview, challenges } = contentLines.reduce(
		({ overview, challenges, isInChallengesSection }, line, index) => {
			const trimmedLine = line.trim()

			if (isEmptyLine(trimmedLine)) {
				return {
					overview,
					challenges,
					isInChallengesSection:
						!isInChallengesSection &&
						overview !== '' &&
						!startsWithChallenge
							? true
							: isInChallengesSection,
				}
			}

			const isFirstNonEmptyLine =
				index === contentLines.findIndex((line) => line.trim() !== '')
			const lineIsChallenge =
				trimmedLine.match(/^\d+\.\s*(\S.*)$/) != null

			if (isFirstNonEmptyLine && lineIsChallenge) {
				return {
					overview,
					challenges: processChallengeLine(trimmedLine, challenges),
					isInChallengesSection: true,
				}
			}

			if (!isInChallengesSection) {
				return {
					overview: appendToOverview(trimmedLine, overview),
					challenges,
					isInChallengesSection,
				}
			} else {
				return {
					overview,
					challenges: processChallengeLine(trimmedLine, challenges),
					isInChallengesSection,
				}
			}
		},
		{
			overview: '',
			challenges: [] as string[],
			isInChallengesSection: startsWithChallenge,
		}
	)

	return { overview, challenges }
}

const isEmptyLine = (line: string): boolean => line === ''

const appendToOverview = (line: string, overview: string): string =>
	overview + (overview ? '\n' : '') + line

const processChallengeLine = (line: string, challenges: string[]): string[] => {
	const challengeMatch = line.match(/^\d+\.\s*(\S.*)$/)
	if (challengeMatch) {
		return [...challenges, challengeMatch[1]]
	} else if (line) {
		return [...challenges, line]
	}
	return challenges
}
